import React, { useState, useRef, useEffect } from 'react';
import { useField } from '@unform/core';

import { MdInsertPhoto } from 'react-icons/md';
import { toast } from 'react-hot-toast';

import { Container, DefaultAvatar } from './styles';
import api from '~/services/api';
import {
  Button as ButtonUi,
  Modal as TakeatModal
} from 'takeat-design-system-ui-kit';
import PersonalButton from '~/components/Buttons/PersonalButton';
import PersonalOutlineButton from '~/components/Buttons/PersonalOutlineButton';

export default function ImageInput({
  name,
  product,
  products,
  setProducts,
  setProduct,
  complement,
  isComplement = false,
  setSelectedComplement = false,
  setCategories,
  allCategories,
  ...rest
}) {
  const ref = useRef(null);
  const { fieldName, registerField, defaultValue } = useField(name);

  const [fileId, setFileId] = useState(defaultValue && defaultValue.id);
  const [preview, setPreview] = useState(defaultValue && defaultValue.url);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: 'dataset.fileid',
      clearValue() {
        if (ref.value) {
          ref.value = '';
        }
        setPreview(null);
      },
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (defaultValue) {
      setPreview(defaultValue.url);
      setFileId(defaultValue.id);
    }
  }, [defaultValue]);

  async function handleChange(e) {
    try {
      const data = new FormData();

      data.append('file', e.target.files[0]);

      const response = await api.post('restaurants/files', data);
      toast.success('Imagem incluída com sucesso');
      const { id, url, name: nameData, path, updatedAt } = response.data;

      setFileId(id);
      setPreview(url);

      if (!isComplement && !complement && products) {
        const productFind = products.findIndex(
          (prod) => prod.id === product.id
        );

        const newProductsArray = [...products];
        const imageData = {
          url,
          id,
          name: nameData,
          path,
          updatedAt,
        };

        newProductsArray[productFind] = {
          ...product,
          image: imageData,
        };

        const newProductsState = [...newProductsArray];

        setProducts(newProductsState);
        setProduct({
          ...product,
          image: imageData,
        });
      }

      // if (isComplement) {
      //   const newCategories = [...products];

      //   newCategories.map((cat, idix) =>
      //     cat.complements.map((item, idex) => {
      //       if (item.id === product.id) {
      //         newCategories[idix].complements[idex] = {
      //           ...item,
      //           image: {
      //             url,
      //             id,
      //             name: nameData,
      //             path,
      //             updatedAt,
      //           },
      //         };
      //       }
      //     })
      //   );

      //   setCategories(newCategories);
      // }

      // if(isComplement){
      //   const newCategories = [...allCategories];

      //   newCategories.map((cat, idix) =>
      //     cat.complements.map((item, idex) => {
      //       if (item.id === complement.id) {
      //         newCategories[idix].complements[idex] = {...complement, image: {
      //                       url,
      //                       id,
      //                       name: nameData,
      //                       path,
      //                       updatedAt,
      //                     }};
      //       }
      //     })
      //   );
  
      //   setCategories(newCategories);
      //   }
    } catch (err) {
      toast.error('Erro ao atualizar imagem');
      console.log(err);
    }
  }

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  
  async function handleOpenDeleteImage() {
    setIsOpenDeleteModal(true);
  }

  async function handleCloseDeleteImage() {
    setIsOpenDeleteModal(false);
  }

  async function handleDeleteProductImage() {
    try {
      handleCloseDeleteImage();

      const response = await api.delete(`restaurants/files/${fileId}`);

      if (response.status === 200) {
        toast.success('Imagem excluída com sucesso');
        
        setFileId(null);
        setPreview(null);

        setProduct(prev => ({
          ...prev,
          image: null
        }));
        
        const productFind = products.findIndex(
          (prod) => prod.id === product.id
        );

        const newProductsArray = [...products];

        newProductsArray[productFind] = {
          ...product,
          image: null
        };

        const newProductsState = [...newProductsArray];
        setProducts(newProductsState);
      } else {
        toast.error('Erro ao deletar imagem');
      }
    } catch(e) {
      throw e;
    }
  }

  return (
    <>
      <Container>
        <div>
          <label htmlFor="avatar">
            {preview ? (
              <img src={preview} alt="User Avatar" />
            ) : (
              <DefaultAvatar>
                <MdInsertPhoto size={45} color="#ddd" />
                <span>Adicionar Foto</span>
              </DefaultAvatar>
            )}
            <input
              type="file"
              id="avatar"
              accept="image/*"
              data-fileid={fileId}
              onChange={handleChange}
              ref={ref}
              {...rest}
            />
          </label>
        </div>
        <section>
          {fileId && <ButtonUi 
            onClick={handleOpenDeleteImage}
            variant='text' 
            type='button'
            style={{
              color: '#dc3545',
            }}
          >Excluir imagem</ButtonUi>}
        </section>
      </Container>
      <TakeatModal
        open={isOpenDeleteModal}
        style={{
          width: '114px',
          height: '132px',
          zIndex: '20 !important'
        }}
      >
        <TakeatModal.Header>
          Tem certeza de que deseja excluir essa imagem?
        </TakeatModal.Header>
        <TakeatModal.Footer>
          <PersonalButton
            color="#FF2C3A"
            message="Cancelar"
            style={{
              marginLeft: 0,
            }}
            onClick={handleCloseDeleteImage}
          />
        <PersonalOutlineButton
          color="#fff"
          fontColor="#0CCAB4"
          borderColor="#0CCAB4"
          message="Salvar e sair"
          type="button"
          onClick={handleDeleteProductImage}
        />
        </TakeatModal.Footer>
      </TakeatModal>
    </>
  );
}
